<div class="col-12"
    [ngClass]="item?.alignment" 
    [style.padding-top.px]="item?.padding"
    [style.padding-bottom.px]="item?.padding" 
    *ngIf="item?.type == 'LINK'" 
>
    <ng-container *ngIf="!item?.content?.link?.includes('http')">
        <a routerLink="{{ item?.content?.link }}">
            <button type="button" class="btn btn-lg text-primary font-size-16 font-weight-bold">
                {{ item?.content?.text }} <img loading="lazy" src="assets/img/icons/icn-arrow-forward-blue.svg" />
            </button>
        </a>
    </ng-container>

    <ng-container *ngIf="item?.content?.link?.includes('http')">
        <a href="{{ item?.content?.link }}" target="_blank">
            <button type="button" class="btn btn-lg text-primary font-size-16 font-weight-bold">
                {{ item?.content?.text }} <img loading="lazy" src="assets/img/icons/icn-arrow-forward-blue.svg" />
            </button>
        </a>
    </ng-container>
</div>